import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../APIHelpers/Responses";

export const studyFactorServices = {
  //Event Factor
  addNewFactor,
  updateFactor,
  getHeighestVersionFactorHistory,
  deleteFactor,
  softDeleteRestoreFactor,
  getFactor,
  getFactorAuditTrials,
  getAssigedFactorinSites
};

// Get Study Event Factor
async function getFactor(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getFactor/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getFactor/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Event Factor
async function addNewFactor(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewFactor`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Event Factor
async function updateFactor(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateFactor`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Event Factor
async function softDeleteRestoreFactor(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreFactor`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Event Factor
async function deleteFactor(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteFactor`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Sequence Row Heighest version
async function getHeighestVersionFactorHistory(studyId, factorId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getHeighestVersionFactorHistory/${studyId}/${factorId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Study Event Factor Row Audit Trial
async function getFactorAuditTrials(studyId, factorId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getFactorAuditTrials/${studyId}/${factorId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Assigned Factor in Site
async function getAssigedFactorinSites(studyId, siteId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getAssigedFactorinSites/${studyId}/${siteId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}